// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes YZbN9DXMsReMsB {
  0% {
    opacity: 0.6;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.6;
  }
}
@keyframes lLUbWQKmsJB8a4 {
  0% {
    transform: scale(0.8);
  }
  100% {
    transform: scale(1);
  }
}
.lLUbWQKmsJB8a4 {
  animation: lLUbWQKmsJB8a4 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;
}
.YZbN9DXMsReMsB {
  width: var(--skeleton-width, 60px);
  height: 16px;
  animation: YZbN9DXMsReMsB 1s ease-in-out infinite;
  border-radius: var(--ds-border-radius, 4px);
  background-color: var(--ds-background-neutral, #171717);
}
.nJNfvn6IhFsEsh {
  display: flex;
  align-items: center;
  gap: var(--ds-space-050, 4px);
}
.N5WUBI_lHr2jW0 {
  display: inline-flex;
  align-items: center;
  transition: transform 0.5s linear;
}
.Ig_WmHgffn_j1f {
  transform: scale(1.1);
}
.rpu7vgT3Op4k2n {
  transform: scale(1);
}
`, ""]);
// Exports
export var dueDateFadeIn = `lLUbWQKmsJB8a4`;
export var dueDateSkeletonPulse = `YZbN9DXMsReMsB`;
export var badgeContent = `nJNfvn6IhFsEsh`;
export var repeatIcon = `N5WUBI_lHr2jW0`;
export var repeatIconProcessing = `Ig_WmHgffn_j1f`;
export var repeatIconNormal = `rpu7vgT3Op4k2n`;
export default ___CSS_LOADER_EXPORT___;
